import styled from 'styled-components';
import AntdLayout from 'antd/es/layout';
import { Screens } from 'core/CssVariables';

const { Sider: AntdSider, Content: AntdContent } = AntdLayout;

export const SSlider = styled(AntdSider)`
  background-color: ${props => props.theme.sidebar.menuBackgroundColor};
  height: 100vh;
  overflow: auto;
  /* The design closes the panel with a rule on its right edge (per-side stroke
     {right: 1} on the Sidebar component), separating it from the content. */
  border-right: 1px solid ${props => props.theme.sidebar.borderColor};

  /* The panel's own children stack as a column so the version bar's
     margin-top:auto can pin it to the bottom of the rail rather than leaving it
     floating under the last menu item. */
  .ant-layout-sider-children {
    display: flex;
    flex-direction: column;
    min-height: 100%;
  }
  .sidebar-switcher {
    position: absolute;
    top: 15px;
    right: 10px;
    z-index: 1;
  }
  @media (max-width: ${Screens.ScreensMD}) {
    position: fixed;
    z-index: 2;
  }
`;

export const SContentLayout = styled(AntdLayout)`
  height: 100%;
  background-color: ${props => props.theme.backgroundColor};
  @media (max-width: ${Screens.ScreensMD}) {
    margin-left: 0;
  }
`;

export const SContent = styled(AntdContent)`
  padding: 0 16px;
  /* Tighter horizontal padding on small laptops so 10-column tables
     and dashboard cards keep more room before they have to reflow
     or scroll. */
  @media (max-width: ${Screens.ScreensLaptopSm}) {
    padding: 0 10px;
  }
`;

export const SLayout = styled(AntdLayout)`
  overflow: hidden;
  background-color: ${props => props.theme.backgroundColor};
  height: 100vh;
`;
